import persistCalendarsSelection from './persistCalendarsSelection';
import { selectCalendar } from './selectCalendar';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { removeCalendarItems } from 'owa-calendar-surface-dategrid';
import { getCalendarSurfaceStore } from 'owa-calendar-surface-surface-store';
import { trace } from 'owa-trace';
import {
    getSelectedCalendars,
    isSelectedCalendar,
    unselectCalendar as unselectCalendarAction,
} from 'owa-calendar-surface-calendars-store';
import {
    Calendar,
    getDefaultCalendar,
    getCalendarFolderId,
    getCalendarEntryByFolderId,
} from 'owa-calendar-cache';
import { linkedCalendarSelected } from './internalActions';
import { isOldModelSharedCalendar } from 'owa-calendar-properties';
import {
    lazyHasCurrentlyDisplayedView,
    lazyUpdateCurrentlyDisplayedViewId,
} from 'owa-save-calendar-view-data';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Action to unselect calendar
 */
export let unselectCalendar = createLegacyActionWithDatapoint('UnselectCalendar')(
    function unselectCalendar(calendar: Calendar) {
        if (isFeatureEnabled('cal-saveCalendarView')) {
            const hasCurrentlyDisplayedView = lazyHasCurrentlyDisplayedView.tryImportForRender();
            const updateCurrentlyDisplayedViewId = lazyUpdateCurrentlyDisplayedViewId.tryImportForRender();
            if (updateCurrentlyDisplayedViewId && hasCurrentlyDisplayedView?.()) {
                updateCurrentlyDisplayedViewId(null);
            }
        }
        if (!isSelectedCalendar(calendar)) {
            trace.info(
                `[unselectCalendar] Cannot find calendar in selected calendars: ${calendar.id}`
            );
            return;
        }

        const defaultCalendar = getDefaultCalendar();

        if (getSelectedCalendars().length == 1 && calendar.id == defaultCalendar.id) {
            trace.info('Cannot unselect only selected default calendar');
            return;
        }

        trace.info(`[unselectCalendar] Unselecting calendar: ${calendar.id}`);
        unselectCalendarAction(calendar);

        const folderId = getCalendarFolderId(calendar);
        const surfaceItemsForFolder = getCalendarSurfaceStore().calendarItems.filter(
            items => items.ParentFolderId.Id === folderId
        );
        removeCalendarItems(
            surfaceItemsForFolder.map(itemToRemove => itemToRemove.ItemId.Id),
            getCalendarSurfaceStore()
        );

        if (isOldModelSharedCalendar(getCalendarEntryByFolderId(folderId))) {
            linkedCalendarSelected(false);
        }
        // TODO VSO 90363: Remove duplicated selection logic
        if (getSelectedCalendars().length === 0) {
            trace.info('Auto-selecting default calendar');
            selectCalendar(defaultCalendar);
        } else {
            persistCalendarsSelection(calendar.id.mailboxInfo.userIdentity);
        }
    }
);

export default unselectCalendar;
